// Fetch list

export const FETCH = 'transportTypes.FETCH'
export const FETCH_STARTED = 'transportTypes.FETCH_STARTED'
export const FETCH_FULFILLED = 'transportTypes.FETCH_FULFILLED'
export const FETCH_REJECTED = 'transportTypes.FETCH_REJECTED'
export const FETCH_CANCELLED = 'transportTypes.FETCH_CANCELLED'

export const SORTING_CHANGED = 'transportTypes.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'transportTypes.FETCH_ONE'
export const FETCH_ONE_STARTED = 'transportTypes.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'transportTypes.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'transportTypes.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'transportTypes.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'transportTypes.SAVE'
export const SAVE_STARTED = 'transportTypes.SAVE_STARTED'
export const SAVE_FULFILLED = 'transportTypes.SAVE_FULFILLED'
export const SAVE_REJECTED = 'transportTypes.SAVE_REJECTED'
export const SAVE_CANCELLED = 'transportTypes.SAVE_CANCELLED'

// Delete

export const DELETE = 'transportTypes.DELETE'
export const DELETE_STARTED = 'transportTypes.DELETE_STARTED'
export const DELETE_FULFILLED = 'transportTypes.DELETE_FULFILLED'
export const DELETE_REJECTED = 'transportTypes.DELETE_REJECTED'
export const DELETE_CANCELLED = 'transportTypes.DELETE_CANCELLED'

// Export

export const EXPORT = 'transportTypes.EXPORT'
export const EXPORT_FULFILLED = 'transportTypes.EXPORT_FULFILLED'
